import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleRoadTaxRecordCategoryEnum } from '../enums/vehicle-road-tax-record-category.enum';
import { VehicleRoadTaxStatusEnum } from '../enums/vehicle-road-tax-status.enum';

/**
 * Vehicle road taxes filters
 */
export class VehicleRoadTaxesFilters extends ApiRequestFilters {
	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossFrom?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossTo?: number;

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Status values
	 */
	statuses?: VehicleRoadTaxStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: VehicleRoadTaxRecordCategoryEnum[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
